<template>
  <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
    <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Font Weight</span>
    <div class="wf-w-1/2">
      <VueSlider
        ref="size-slider"
        v-model="fontWeight"
        :interval="1"
        adsorb
        tooltip="none"
        :duration="0"
        :data="fontWeightClasses"
      />
    </div>
  </li>
</template>

<script>
  import _ from 'lodash'
  import { FontWeightClasses } from '../classes/FontWeightClasses'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      fontWeightClasses() {
        return Object.keys(FontWeightClasses)
      },
      fontWeight: {
        get() {
          let currentFontWeight = this.elementClasses(this.classes)[this.device].find(elementClass => this.fontWeightClasses.includes(elementClass.value))
          if (! currentFontWeight) {
            currentFontWeight = {property: 'FontWeight', value: 'BOLD', touched: false}
            this.addToArray(this.module, [currentFontWeight], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentFontWeight.value
        },
        set: _.debounce(function (value) {
          let currentFontWeight = this.elementClasses(this.classes)[this.device].find(elementClass => this.fontWeightClasses.includes(elementClass.value))
          value = {property: 'FontWeight', value: value, touched: currentFontWeight.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    }
  })
</script>